import { TDictionary } from '@/common/types/dictionary';

export const generateCodeProductOptions = (): Array<TDictionary> => {
  const range = {
    start: 0,
    end: 10,
  };
  const result: Array<TDictionary> = [];

  for (let i = range.start; i <= range.end; i += 2) {
    result.push({
      id: i,
      name: i.toString(),
    });
  }

  return result;
};
